__turbopack_context__.v({
  "badge": "DownloadNH-module__NmzkRG__badge",
  "bgImage": "DownloadNH-module__NmzkRG__bgImage",
  "content": "DownloadNH-module__NmzkRG__content",
  "desc": "DownloadNH-module__NmzkRG__desc",
  "root": "DownloadNH-module__NmzkRG__root",
  "section": "DownloadNH-module__NmzkRG__section",
  "storeImg": "DownloadNH-module__NmzkRG__storeImg",
  "storeLink": "DownloadNH-module__NmzkRG__storeLink",
  "stores": "DownloadNH-module__NmzkRG__stores",
  "title": "DownloadNH-module__NmzkRG__title",
});
